import { Timestamp } from "firebase/firestore";

export class Dob {
    private day: number | null | undefined;
    private month: number | null | undefined;
    private year: number | null | undefined;

    constructor(day: number | null | undefined, month: number | null | undefined, year: number | null | undefined) {
        this.setDay(day);
        this.setMonth(month);
        this.setYear(year);
    }

    static fromJson(json:any) {
        return new Dob(json.day, json.month, json.year);
    }

    setDay(newDay:number | null | undefined) {
        this.day = newDay;
    }
    setMonth(newMonth:number | null | undefined) {
        this.month = newMonth;
    }
    setYear(newYear:number | null | undefined) {
        this.year = newYear;
    }

    getDay() {
        return this.day;
    }
    getMonth() {
        return this.month;
    }
    getYear() {
        return this.year;
    }
}

export class CustomerNotification {
    private approval_requested: boolean | null | undefined;
    private completes_at: Timestamp | null | undefined;

    constructor(approval_requested: boolean | null | undefined, completes_at: Timestamp | null | undefined) {
        this.setApprovalRequested(approval_requested);
        this.setCompletesAt(completes_at);
    }

    static fromJson(json:any) {
        return new CustomerNotification(json.approval_requested, json.completes_at !== null && json.completes_at !== undefined ? new Timestamp(parseInt(json.completes_at), 0) : null);
    }

    setApprovalRequested(newApprovalRequested:boolean | null | undefined) {
        this.approval_requested = newApprovalRequested;
    }
    setCompletesAt(newCompletesAt:Timestamp | null | undefined) {
        this.completes_at = newCompletesAt;
    }

    getApprovalRequested() {
        return this.approval_requested;
    }
    getCompletesAt() {
        return this.completes_at;
    }
}